import React from "react";
import { PlainButton } from "@jugl-web/ui-kit";
import { PinButton } from "../PinButton/PinButton";
import { ReactComponent as ReorderIcon } from "./assets/reorder.svg";

export const SidebarToolItem: React.FC<{
  title: string;
  isPinned: boolean;
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  isAtLimit?: boolean;
  isDraggable?: boolean;
  onPinClick: (e: React.SyntheticEvent) => void;
}> = ({ title, icon: Icon, isPinned, isDraggable, isAtLimit, onPinClick }) => (
  <div className="relative flex h-[41px] items-center gap-2 rounded-lg bg-grey-100 pr-4 pl-2 font-secondary text-sm text-dark">
    {isDraggable && (
      <PlainButton onClick={(event) => event.stopPropagation()}>
        <ReorderIcon />
      </PlainButton>
    )}
    {Icon && <Icon />}
    {title}
    <PinButton
      onClick={onPinClick}
      isPinned={isPinned}
      isAtLimit={isAtLimit}
      className="absolute right-2"
    />
  </div>
);
